import { useV2GetAccountQuery } from "@generated";

const useGetPlanName = () => {
  const { data, isLoading, error } = useV2GetAccountQuery({});
  return {
    planName: (data?.data?.attributes?.["plan-name"] as string) ?? "",
    isLoading,
    error: error ?? null,
  };
};

export default useGetPlanName;
